module.exports = __webpack_public_path__ + "static/media/trust-icon.562a2243.svg";